<template>
  <div class="mt-4">
    <div class="text-xs-right">
      <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
        <v-icon>search</v-icon>
        &nbsp;
        {{ $t('advanced search') }}&nbsp;
        <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
        <em v-else class="fas fa-angle-up" />
      </v-btn>
    </div>
    <div
      v-if="showAdvancedSearch"
      class="mb-4 py-2"
      style="border: 1px solid #eee; border-radius: 10px; position: relative"
    >
      <v-layout wrap class="form-control">
        <v-flex xs12 sm4 px-2>
          <div class="caption">รหัสเพจ</div>
          <multiselect
            v-model="filter.page"
            :options="pageOptions"
            select-label
            name="pageId"
            selected-label
            placeholder="รหัสเพจ"
            label="page_id"
            style="margin-bottom: 4px"
          ></multiselect>
        </v-flex>
        <v-flex xs12 sm4 px-2>
          <div class="caption">ชื่อเพจ</div>
          <input v-model="filter.name" type="text" placeholder="ชื่อเพจ" />
        </v-flex>
        <v-flex xs12 sm4 px-2>
          <div class="caption">หมวดหมู่สินค้า</div>
          <multiselect
            v-model="filter.category"
            :options="categoryOptions"
            select-label
            selected-label
            label="category_name"
          ></multiselect>
        </v-flex>

        <v-flex xs12 class="text-xs-right">
          <v-btn outline color="grey" @click="handleClearSearch">{{ $t('Clear Search') }}</v-btn>
          <v-btn depressed color="primary" @click="handleSearch">
            <em class="fas fa-search mr-1" />
            {{ $t('Search') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>

    <div class="broadcasts mt-3">
      <div v-if="currentView === 'form-manage'" class="broadcast mb-3">
        <page-manage :type="'add'" @close="currentView = 'list'" @onSuccess="handleSaveSuccess" />
      </div>
      <template v-else>
        <div style="margin-bottom: 15px">
          <a
            href="javascript:void(0);"
            style="text-decoration: none"
            @click="
              selectedPage = undefined
              currentView = 'form-manage'
            "
          >
            <div class="add-broadcast text-xs-center">
              <em class="fa fa-plus middle" />
              {{ $t('add_new_page') }}
            </div>
          </a>
        </div>
      </template>

      <template v-for="(item, index) in pageList">
        <PageItem :key="`page-${index}`" :item="item" @onUpdateSuccess="handleSaveSuccess" />
      </template>
      <div class="mt-2 text-xs-right">
        <v-pagination
          v-model="pageNumber"
          :total-visible="6"
          :length="pageLength"
          @input="handleChangePage"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tcpApi from '@/api/tcp'
import PageItem from './PageItem.vue'
import PageManage from './PageManage'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    PageItem,
    PageManage,
    Multiselect
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      total: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      pageTemp: 1,
      pageNumber: 1,
      pageList: [],
      showAdvancedSearch: false,
      filter: {
        page: '',
        name: '',
        category: ''
      },
      selectedPage: null,
      currentView: 'list',
      formType: 'add'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory'
    }),
    categoryOptions() {
      let options = []
      if (this.categories && this.categories.length > 0) {
        options = this.categories.map((category) => {
          return {
            category_id: category.id,
            category_name: category.name
          }
        })
      }
      return options
    },
    pageLength() {
      if (this.total) {
        const total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    pageOptions() {
      return this.$store.state.tcpSubpages
    }
  },
  mounted() {
    if (this.categories.length === 0) {
      this.$store.dispatch('loadCategory')
    }

    if (!this.$store.state.tcpSubpages) {
      this.$store.dispatch('getTcpSubpages')
    }

    this.handleFetchAllShopPage()
  },
  methods: {
    async handleFetchAllShopPage() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const data = {
          offset: vm.offset,
          limit: vm.limit
        }

        if (vm.filter.page) {
          Object.assign(data, { page_id: vm.filter.page.page_id })
        }
        if (vm.filter.name) {
          Object.assign(data, { name: vm.filter.name })
        }
        if (vm.filter.category) {
          Object.assign(data, { category_id: vm.filter.category.category_id })
        }
        const response = await tcpApi.postGetShopPageWithMasterPageId({
          master_page_id: vm.selectedBot.pageid,
          data
        })
        vm.$store.commit('CLEAR_LOADING')

        if (response && response.status == 200 && response.data && response.data.data) {
          vm.pageList = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    handleResetFilter() {
      this.offset = 0
    },
    handleSearch() {
      this.handleResetFilter()
      this.handleFetchAllShopPage()
    },
    handleClearSearch() {
      this.filter = {
        page: '',
        name: '',
        category: ''
      }
      this.handleResetFilter()
      this.handleFetchAllShopPage()
    },
    handleSaveSuccess() {
      this.currentView = 'list'
      this.handleFetchAllShopPage()
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pageTemp !== val) {
        vm.pageTemp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        vm.handleFetchAllShopPage()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/PageManagement/PageManagement.vue